import { render, staticRenderFns } from "./MotorPickerType.vue?vue&type=template&id=8c8ff852"
import script from "./MotorPickerType.vue?vue&type=script&lang=js"
export * from "./MotorPickerType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports